import {type StateCreator} from 'zustand'

export interface GameActionButtonsSlice {
    gameActionButtons: {
        isCityImprovementExtraButtonsOpen: boolean
        isKnightActionExtraButtonsOpen: boolean
        setCityImprovementExtraButtonsOpen: (isOpen: boolean) => void
        setKnightActionExtraButtonsOpen: (isOpen: boolean) => void
        closeAllExtraButtons: () => void
    }
}

export const createGameActionButtonsSlice: StateCreator<GameActionButtonsSlice> = (set) => ({
    gameActionButtons: {
        isCityImprovementExtraButtonsOpen: false,
        isKnightActionExtraButtonsOpen: false,
        setCityImprovementExtraButtonsOpen: (isOpen) => set((state) => ({
            gameActionButtons: {
                ...state.gameActionButtons,
                isCityImprovementExtraButtonsOpen: isOpen,
                isKnightActionExtraButtonsOpen: isOpen ? false : state.gameActionButtons.isKnightActionExtraButtonsOpen,
            },
        })),
        setKnightActionExtraButtonsOpen: (isOpen) => set((state) => ({
            gameActionButtons: {
                ...state.gameActionButtons,
                isKnightActionExtraButtonsOpen: isOpen,
                isCityImprovementExtraButtonsOpen: isOpen ? false : state.gameActionButtons.isCityImprovementExtraButtonsOpen,
            },
        })),
        closeAllExtraButtons: () => set((state) => ({
            gameActionButtons: {
                ...state.gameActionButtons,
                isCityImprovementExtraButtonsOpen: false,
                isKnightActionExtraButtonsOpen: false,
            },
        })),
    },
})
